var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSymbol2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.02 28.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_2-2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.35,20.32H61a7.78,7.78,0,0,0-1,.05h0a8.68,8.68,0,0,0-.89.14l-.18,0c-.24.05-.47.11-.7.18l-.24.08-.61.22-.26.12-.55.26-.26.15c-.17.09-.34.2-.51.31l-.25.16-.47.36-.24.19-.44.4-.21.2-.42.46c-.05.07-.11.13-.17.2s-.28.36-.41.55l-.12.16a10.13,10.13,0,0,0-.86,1.59s0,0,0,.05c-.11.26-.2.52-.29.79l-.06.23c-.06.21-.12.43-.17.65s0,.2-.05.3,0,.29-.07.44h25A9.55,9.55,0,0,0,86,20.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.06,28.61A12.05,12.05,0,0,1,61,17.83h1.6L48.78,1.48A4.57,4.57,0,0,0,46.57,0V14.32a16.82,16.82,0,0,1-.8,5.13h0c-.15.47-.32.92-.51,1.37,0,.12-.11.24-.17.36-.14.32-.28.63-.44.94l-.25.44c-.15.27-.3.53-.46.78s-.2.31-.31.46-.33.47-.5.7l-.35.44c-.18.22-.37.44-.56.65s-.24.27-.37.4-.41.41-.63.61l-.38.35c-.24.21-.49.41-.74.6s-.22.19-.34.27c-.35.26-.71.51-1.08.74l-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.12,3.39,31.26,13.84h0L28,17.64l-.16.19H43.64a14.79,14.79,0,0,0,.43-3.51V0a4.59,4.59,0,0,0-2.32,1.47l-1.63,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.42,11.78H29.73l1.74-2,5.87-6.94a12.47,12.47,0,0,0-10.26-1.5A12.32,12.32,0,0,0,18.42,11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.75,20.33H16.48a9.5,9.5,0,0,0-1.31.08,9.22,9.22,0,0,0-1.31.28c-.15,0-.28.1-.42.15a8.29,8.29,0,0,0-.83.31l-.47.23c-.23.13-.47.25-.69.39a4.63,4.63,0,0,0-.46.31c-.2.15-.41.29-.6.46a5.14,5.14,0,0,0-.42.38c-.19.17-.36.34-.53.52s-.25.29-.37.44a6.7,6.7,0,0,0-.45.6c-.11.16-.21.32-.31.48s-.25.44-.36.67-.17.34-.24.52-.06.17-.1.25a15.57,15.57,0,0,0,8,2.21H29.78A14.25,14.25,0,0,0,42.75,20.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.51,24.9a12,12,0,0,1,9.34-7,12.74,12.74,0,0,1,1.63-.1H24.6l3-3.55H0A15.62,15.62,0,0,0,5.51,24.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol2);
export default __webpack_public_path__ + "static/media/logo_symbol_2.b5285cd3651c8ed9279ca142f19f3de8.svg";
export { ForwardRef as ReactComponent };